import { enqueueSnackbar } from "notistack";
import { apiCall } from ".";
import { getTenant } from "../handlers/getTenant";
import { getSession } from "./../handlers/getSession";
import { getErrorMessage } from "./errorMessages";

//function to handle errors and display them to the user
const showErrorMessage = (message) => {
  enqueueSnackbar(message, {
    variant: "error",
    preventDuplicate: true,
    autoHideDuration: 10000,
  });
};

export const renderFormToReport = async () => {
  const tenant = getTenant();
  try {
    const resp = await apiCall.get(`${tenant}/api/render-form-to-report/`);
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "forms"));
    console.error(error);
  }
};

// CURRENT REPORT
// businessUnitKey (opcional): la unidad de negocio cuyo formulario vigente se
// quiere. Sin ella, el backend cae al formulario default del tenant
// (business_unit IS NULL) — el comportamiento historico. Con ella,
// resolve_form devuelve el formulario de esa unidad.
export const getDetailCurrentReport = async (businessUnitKey = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const query = businessUnitKey
      ? `?business_unit_key=${encodeURIComponent(businessUnitKey)}`
      : "";
    const resp = await apiCall.get(`${tenant}/api/form/current/${query}`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "forms"));
    console.error(error);
  }
};

// Ultimo formulario por unidad de negocio (DISTINCT ON business_unit en el
// backend). Puebla el selector de "nuevo reporte": cada fila trae la llave de
// una unidad, mas la fila del default del tenant (business_unit null) cuando
// existe. En un cliente legacy sin unidades configuradas, la lista trae solo
// esa fila null, y el selector se resuelve como el comportamiento actual.
// Devuelve metadatos ligeros (id, business_unit, ...), no los stepers: el
// formulario completo se pide con getDetailCurrentReport al elegir la unidad.
export const getLatestFormsByBusinessUnit = async () => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(`${tenant}/api/form/list/latest/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "forms"));
    console.error(error);
  }
};

export const getFormsList = async () => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(`${tenant}/api/form/list/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "forms"));
    console.error(error);
  }
};

export const editForms = async (id = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.put(`${tenant}/api/forms/edit/${id}`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "forms"));
    console.error(error);
  }
};

export const getFormDetails = async (id = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(`${tenant}/api/form/detail/${id}/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "forms"));
    console.error(error);
  }
};

export const createForm = async (form = {}) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(`${tenant}/api/form/create/`, form, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "forms"));
  }
};

export const deleteForm = async (id = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.delete(`${tenant}/api/forms/delete/${id}/`, id, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "forms"));
  }
};

// Get list Report Forms
export const ListReportForms = async () => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(`${tenant}/api/form/list/report/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "forms"));
  }
};

export const getReclasificationReport = async (id = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/report/group_fields_by_form/?report_id=${id}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "forms"), { cause: error });
  }
};

export const updateReclasificationReport = async (id = "", newValues) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/report/reclassificate_report/?report_id=${id}`,
      newValues,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "forms"), { cause: error });
  }
};
